import { post_Json } from '@/jsUtils/nodejsRequest';
export default {
  data() {
    return {
      imglike: require('@/assets/public/like.png'),
      imgliked: require('@/assets/public/liked.png'),
      imgunlike: require('@/assets/public/unlike.png'),
      imgunliked: require('@/assets/public/unliked.png'),
      imglike_show: "",
      imgunlike_show: "",
      likestatus: false,
      unlikestatus: false,
      currentimgInfo: {
        id: "",
        likestatus: false,
        unlikestatus: false
      }
    };
  },
  emits: ["onClicklike"],
  props: {
    imginfo: {
      Type: Object,
      default: {
        id: 0,
        like: false,
        unlike: false
      }
    }
  },
  watch: {
    imginfo: {
      handler: function (val, oldVal) {
        this.onUpdatelike(val);
      },
      deep: true
    }
  },
  mounted() {
    this.selfUpdatelike(this.imginfo);
  },
  methods: {
    like() {
      if (this.likestatus == false) {
        this.likestatus = true;
        this.unlikestatus = false;
        this.imglike_show = this.imgliked;
        this.imgunlike_show = this.imgunlike;
      } else {
        this.likestatus = false;
        this.imglike_show = this.imglike;
      }
      // 强行刷新
      this.$forceUpdate();
      this.currentimgInfo.id = this.imginfo.id;
      this.currentimgInfo.likestatus = this.likestatus;
      this.currentimgInfo.unlikestatus = this.unlikestatus;
      let respdata = this.imginfo;
      respdata.likestatus = this.likestatus;
      respdata.unlikestatus = this.unlikestatus;
      this.$emit("onClicklike", respdata);

      // 发送统计数据
      let logdata = {
        "image_name": this.imginfo.id,
        "product_name": this.imginfo.product_type
      };
      this.sendStatisticData("image_like", logdata);
    },
    unlike() {
      if (this.unlikestatus == false) {
        this.unlikestatus = true;
        this.likestatus = false;
        this.imgunlike_show = this.imgunliked;
        this.imglike_show = this.imglike;
      } else {
        this.unlikestatus = false;
        this.imgunlike_show = this.imgunlike;
      }
      // 强行刷新
      this.$forceUpdate();
      this.currentimgInfo.id = this.imginfo.id;
      this.currentimgInfo.likestatus = this.likestatus;
      this.currentimgInfo.unlikestatus = this.unlikestatus;
      let respdata = this.imginfo;
      respdata.likestatus = this.likestatus;
      respdata.unlikestatus = this.unlikestatus;
      this.$emit("onClicklike", respdata);

      // 发送统计数据
      let logdata = {
        "image_name": this.imginfo.id,
        "product_name": this.imginfo.product_type
      };
      this.sendStatisticData("image_unlike", logdata);
    },
    onUpdatelike(imginfo) {
      this.selfUpdatelike(imginfo);
    },
    selfUpdatelike(imginfo) {
      this.likestatus = imginfo.likestatus;
      this.unlikestatus = imginfo.unlikestatus;
      if (this.likestatus == true) {
        this.imglike_show = this.imgliked;
      } else {
        this.imglike_show = this.imglike;
      }
      if (this.unlikestatus == true) {
        this.imgunlike_show = this.imgunliked;
      } else {
        this.imgunlike_show = this.imgunlike;
      }
    },
    //发送统计数据
    sendStatisticData(event, logdata) {
      let data = {
        "event": event,
        "data": logdata
      };
      let stat_url = '/imageprocesshost' + '/statistic';
      post_Json(stat_url, data).then(res => {
        // 不做任何事情
      });
    }
  }
};